import React, { useEffect } from 'react';
import { Link } from 'react-router';

import {
  FormControl,
  Box,
  FormHelperText,
  InputLabel,
  Select,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useUser } from '@/providers';

import STORAGE_TYPES from '../../jobs/JobForm/storageTypes';
import renderThirdPartyMenuOption from '../../shared/renderThirdPartyMenuOption';
import { fetchCredentials } from '../../../actions/projectCredentials';

export default function CollectionOutputTypeField({
  entity_type,
  value,
  error,
  setValue,
  setChanged,
  edit,
}) {
  const dispatch = useDispatch();
  const user = useUser();
  const project_credentials = useSelector((state) => state.projectCredentials);

  useEffect(() => {
    (async () => {
      if (project_credentials === null) {
        if (user?.selected_project) {
          dispatch(fetchCredentials(user.selected_project));
        }
        return;
      }
    })();
  }, [dispatch, project_credentials, user?.selected_project]);

  const handleChange = (event) => {
    const { value: newValue } = event.target;
    if (newValue !== value) {
      setChanged();
    }
    setValue(newValue);
  };
  const project_key_types = project_credentials
    ? project_credentials.map((key) => key.type)
    : [];

  return (
    <Box>
      <FormControl fullWidth required>
        <InputLabel id='output-type-label'>Output Type</InputLabel>
        <Select
          labelId='output-type-label'
          id='output_type'
          value={value}
          label='Source Type'
          aria-describedby='output-type-helper-text'
          onChange={handleChange}
          disabled={edit}
          error={Boolean(error)}
        >
          {STORAGE_TYPES.export.map((type) =>
            renderThirdPartyMenuOption(
              type,
              project_key_types,
              user.cloudbender_enabled
            )
          )}
        </Select>
        {error ? (
          <FormHelperText id='output-type-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='output-type-helper-text'>
            Select the storage type to export the {entity_type} to. Configure
            available storage types by{' '}
            <Link
              to={
                user.id === user.selected_project
                  ? '/account/settings'
                  : `/project/details/${user.selected_project}`
              }
              target='_blank'
            >
              adding third-party credentials.
            </Link>
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
